import { render, staticRenderFns } from "./AccountStep.vue?vue&type=template&id=895bd1ea&"
import script from "./AccountStep.vue?vue&type=script&lang=ts&"
export * from "./AccountStep.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('895bd1ea')) {
      api.createRecord('895bd1ea', component.options)
    } else {
      api.reload('895bd1ea', component.options)
    }
    module.hot.accept("./AccountStep.vue?vue&type=template&id=895bd1ea&", function () {
      api.rerender('895bd1ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/LobbySteps/AccountStep.vue"
export default component.exports